import { useTranslation } from "react-i18next"
import { ActivityListProps } from "./types"
import { ActivityItem } from "../activityItem"
import { NoResponse } from "../../../../../../../components/errors/noResponse"
import { ScrollContainer } from "../../../../../../../components/scrollContainer"
import { ActivityListHeader } from "../activityListHeader"
import Loader from "../../../../../../../components/loader"

export const MyActivityList = ({ list, title, amount, id, arrayExpand, expandChild, usersToView, displayActivityListUsers, usersToDisplayed, menuOption, area, curp, deaprtment, division, role, listLocal, localLoad, types, assignData }: ActivityListProps) => {
    const { t } = useTranslation()
    
    return (
        <>
            {localLoad ?
                <Loader />
                :
                <ScrollContainer maxHeight="650px" showVerticalScroll sx={{
                    width: '100%',
                }}>
                    <ActivityListHeader
                        area={area}
                        curp={curp}
                        department={deaprtment}
                        division={division}
                        rol={role}
                        total={amount ?? 0}
                        types={types}
                        more={false}
                    />
                    {!listLocal?.length && <NoResponse label={t('general.noActivities')} />}
                    {
                        listLocal && listLocal.map((userActivity, index) => (
                            <ActivityItem
                                key={userActivity?.id}
                                menuOption={menuOption}
                                expandParent={arrayExpand?.find(item => item.id === userActivity?.id)?.clave ?? false}
                                toggleExpand={expandChild}
                                assignData={assignData}
                                {...userActivity}
                                isVisible={!usersToDisplayed.some(user => user == userActivity?.id)}
                                visibility={{
                                    color: 'primary', onClick: (e) => {
                                        e.stopPropagation()
                                        displayActivityListUsers({ users: userActivity?.id })
                                    }
                                }}
                            />
                        ))
                    }
                </ScrollContainer>
            }
        </>

    )
}